import React from "react";

const ArrowUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg height="16" width="16" viewBox="0 0 16 16" {...props}>
    <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z" />
  </svg>
);
export default ArrowUpIcon;
